module.exports = __webpack_public_path__ + "static/media/17.8d4122ea.jpg";